module.exports = __webpack_public_path__ + "static/media/selfChecker.19434b51.svg";